<template>
  <b-modal
    :visible="fileLogs.batchFileUploadModalShow"
    size="xl"
    title="Upload Status"
    scrollable
    @shown="onShown"
    @hidden="onHideModal"
  >
    <content-spinner
      :show="fileLogs.batchFileUploadLoading"
      :fullscreen="true"
    />
    <h5
      v-if="fileLogs.batchFileUploadErrors"
      class="alert alert-danger"
    >
      {{ fileLogs.batchFileUploadErrors }}
    </h5>
    <no-content
      v-if="allRecord.length === 0"
      :show="true"
      :text="`There are no errors for individual rows.`"
    />
    <b-row v-else>
      <b-col cols="12">
        <div class="d-flex pb-2 justify-content-between main-header-wrapper">
          <div class="d-flex ">
            <b-form-radio
              v-model="selected"
              class=" mr-2"
              value="allRecord"
              @change="onChange"
            >
              Show All Records
            </b-form-radio>
            <b-form-radio
              v-model="selected"
              class=" mr-2"
              value="exceptions"
              @change="onChange"
            >
              Show
              Exceptions
            </b-form-radio>
          </div>


          <div class="d-flex">
            <b-form-select
              v-model="perPage"
              class="per-page-select mr-2"
              :options="perPageOptions"
              @change="onPerPageChange"
            />

            <b-pagination
              v-if="totalRows > perPage"
              v-model="currentPage"
              class="mb-0"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="batch-file-upload"
              @input="onCurrentPageChange"
            />
          </div>
        </div>
        <no-content
          v-if="localItems.length === 0"
          :show="true"
          :text="`There are no errors for individual rows.`"
        />
        <b-table
          v-else
          id="batch-file-upload"
          responsive="sm"
          :fixed="fixed"
          :items="localItems"
          :fields="fields"
          :striped="striped"
          :outlined="outlined"
          :per-page="perPage"
          :current-page="currentPage"
        >
          <template #cell(UploadStatus)="data">
            <div>
              <p
                v-if="data.item.UploadStatus !== 'rejected'"
                class="text-green"
              >
                Success
              </p>
              <p
                v-else
                class="text-red"
              >
                Rejected
              </p>
            </div>
          </template>
          <template #cell(Exception)="data">
            <div>{{ exceptionMessage(data.item) }}</div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../../../core/components/ContentSpinner';

const {mapState, mapActions} = createNamespacedHelpers('monitoring');

import eventBus, {
  ON_MONITORING_FILE_LOGS_GET,
} from '../../../../core/services/event-bus';
import NoContent from '../../../../core/components/NoContent';

export default {
  name: 'BatchFileUploadTableModal',
  components: {NoContent, ContentSpinner},
  props: {
    striped: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected: 'exceptions',
      totalRows: null,
      localItems: [],
      allRecord: [],
      currentPage: 1,
      perPage: 20,
      perPageOptions: [5, 10, 20, 50, 100],
      fields: [
        {key: 'BatchFileUploadId', label: 'Batch File Upload ID', sortable: true},
        {key: 'RecordNumber', label: 'Record Number', sortable: true},
        {key: 'UploadStatus', label: 'Status', sortable: true},
        {key: 'Exception', label: 'Exception', sortable: true},
      ],
    };
  },
  computed: {
    ...mapState(['fileLogs']),
  },
  methods: {
    ...mapActions(['hideBatchFileUploadModal']),
    onHideModal() {
      this.hideBatchFileUploadModal();
      this.currentPage = 1;
      this.perPage = 20;
      this.selected = 'exceptions';
    },
    onChange(e) {
      if (e === 'allRecord') {
        this.localItems = this.fileLogs.batchFileUploadData;
      } else {
        this.localItems = this.fileLogs.batchFileUploadData.filter(b => b.UploadStatus === 'rejected');
      }
      this.totalRows = this.localItems.length;
    },
    exceptionMessage(item) {
      return [...item.ValidationErrors, ...item.ValidationWarnings].filter(el => el.length > 0).join(',');
    },
    onShown() {
      eventBus.$on(ON_MONITORING_FILE_LOGS_GET, () => {
        this.localItems = [...this.fileLogs.batchFileUploadData.filter(b => b.UploadStatus === 'rejected')];
        this.allRecord = [...this.fileLogs.batchFileUploadData];
        this.totalRows = this.localItems.length;
      });
    },
    onCurrentPageChange() {
      this.contextChanged();
      this.$emit('current-page-change', this.currentPage);
    },
    onPerPageChange() {
      this.contextChanged();
      this.$emit('per-page-change', this.perPage);
    },
    contextChanged() {
      const context = {
        pagination: {
          perPage: this.perPage,
          page: this.currentPage,
        },
      };
      this.$emit('context-change', context);
    },
  },
};
</script>

<style scoped>


</style>